__turbopack_context__.v({
  "className": "source_serif_4_5a53e156-module__yOORTG__className",
  "variable": "source_serif_4_5a53e156-module__yOORTG__variable",
});
